import { Suspense, useEffect } from "react";
import { locales } from "../utils/constants";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import { Toaster } from "react-hot-toast";
import { Loader } from "../components/ui/loader";
import { Header } from "../components/header/header";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import AutoScroll from "../utils/autoScroll";
import { Azdararir } from "../components/ui/azdararir";
import { ScrollToTop } from "../components/ui/scrollToTop";
import { Footer } from "../components/footer/footer";

export const Layout = () => {
  const { language } = useParams();
  const { i18n } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    if (!locales?.includes(language)) {
      return navigate("/");
    }

    if (language && i18n.language !== language) {
      i18n.changeLanguage(language);
      cookies.set("i18next", language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return (
    <>
      <Toaster
        toastOptions={{
          style: {
            maxWidth: "100%",
          },
        }}
      />
      <Header />
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
      <AutoScroll />
      <Azdararir />
      <ScrollToTop />
      <Footer />
    </>
  );
};
